<div class="modal-header">
  <button
    type="button"
    class="btn-close"
    (click)="bsModalRef.hide()"
    aria-label="Close"
  >
    <i class="feather x"></i>
  </button>
  <h4 class="modal-title" id="myModalLabel">Upload files</h4>
</div>
<div class="modal-body">
  <label
    class="drag-and-drop-upload"
    appDragDrop
    (onFileDropped)="fileChange($event)"
  >
    <h3>Drag & Drop your files or click here to select</h3>
    <input
      #fileUpload
      accept=".pdf,.doc,.docx,.pptx,.ppt,.xls,.xlsx,.csv,.txt,.rtf,.html,.zip,.mp3,.wma,.mpg,.flv,.avi,.jpg,.jpeg,.png,.gif,.ofx,.qbo,.iif,.qbx,.qbm,.qbb,.qbw"
      type="file"
      (change)="fileChange($event.target.files)"
      multiple
    />
  </label>
  <div class="upload-wrapper" [ngClass]="{ 'border-top': has_file }">
    <div
      class="file-upload-preview generic {{ selectedFile.ext }} item{{ i }}"
      *ngFor="let selectedFile of selectedFiles; let i = index"
    >
      <div class="file-name">{{ selectedFile.filename }}</div>
      <button class="remove-uploaded-file" (click)="removeFile(i)">
        <i class="feather x"></i>
      </button>
    </div>
  </div>
  <div class="upload-recurrency" *ngIf="recurrency">
    <h4>Select an option for the file(s) you will upload:</h4>
    <label for="all_instances"
      ><div class="m-0 label-title">
        <input
          type="radio"
          (change)="handleRecurrencyRadioChange($event)"
          name="recurrency"
          id="all_instances"
          value="all_instances"
          checked
        />
        For all instances
      </div>
      <p style="font-weight: normal">
        Attached file(s) will be preserved when the job is duplicated or into
        future instances, if this is a recurring job.
      </p>
    </label>

    <label for="this_instance"
      ><div class="m-0 label-title">
        <input
          type="radio"
          (change)="handleRecurrencyRadioChange($event)"
          name="recurrency"
          id="this_instance"
          value="this_instance"
        />
        This instance only
      </div>
      <p style="font-weight: normal">
        Attached file(s) are relevant for this instance of the job only.
      </p>
    </label>
  </div>
  <app-progress-bar
    *ngIf="showProgressBar"
    [percentage]="progressPercentage"
    style="display: block; margin: 20px 0"
  ></app-progress-bar>
</div>
<div class="modal-footer">
  <div class="row">
    <div class="col-sm-6 text-left">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">
        Cancel
      </button>
    </div>
    <div class="col-sm-6">
      <button
        type="button"
        class="btn btn-primary"
        (click)="startProgress()"
        [disabled]="showProgressBar || files.length == 0"
      >
        <span>{{ !formdataOnly ? "Upload files" : "Add files" }}</span>
      </button>
    </div>
  </div>
</div>
<div class="upload-loading" *ngIf="is_loading">
  <div>
    <img src="assets/img/ajax-loader.gif" alt="Loading" /> <br />Loading...
  </div>
</div>
